import React, { Component } from "react";

import { Row, Col, Card, CardBody, CardTitle } from "reactstrap";
import { Link } from "react-router-dom";

import ApexRadial from "./ApexRadial";
import  ReactApexChart from 'react-apexcharts';
import PostApiCall from '../../Api'
import GetApiCall from '../../GETAPI'
import Notiflix from "notiflix";

class MonthlyEarning extends Component {
    constructor(props) {
        super(props);
        this.state = {
            series4: [0,0,0,0],
            courseOptions: {
                chart: {
                  type: 'donut',
                },
                labels: ['Thanga Mazhai','Thanga Then','Thanga Malar','My Gold Eleven'],
                responsive: [{
                  breakpoint: 480,
                  options: {
                    chart: {
                      width: 200
                    },
                    fill: {
                      type: 'gradient',
                    },
                    legend: {
                      position: 'bottom'
                    }
                  }
                }]
              },
        }
    }


    componentDidMount(){
        
        GetApiCall.getRequest("Get_ChitSchemaRatio").then(resultdes =>
            resultdes.json().then(objuser => {

                // console.log(objuser)
              let CourseSerice=[]
              let CourseOption=[]
              objuser.data.map(data=>{
                CourseSerice.push(data.CountOf)
                CourseOption.push(`${data.fld_chitschema.slice(0,20)}`+"...")
              }) 

              // console.log(StateOption);

              let TempObje={...this.state.courseOptions,
                labels:CourseOption}
                // console.log(TempObje)
            this.setState({
              series4:CourseSerice,
              courseOptions:TempObje
                })
        
            }))
    }

    render() {
        return (
            <React.Fragment> <Card style={{height:'185px'}}>
                <CardBody>
                    <CardTitle>
                        Chit Scheme Ratio
                    </CardTitle>
                    <Row>
                        <Col sm="12">
                        <div id="chart" >
          <ReactApexChart options={this.state.courseOptions} series={this.state.series4} type="donut" width={325} style={{marginTop:'-10px'}} />
      </div>
                        </Col>
                       
                    </Row>
                   
                </CardBody>
            </Card>
            </React.Fragment>
        );
    }
}

export default MonthlyEarning;
